module.exports = __webpack_public_path__ + "static/media/landing-mobile-1x.b25d43a8.jpg";